import { przezmorzeApi } from "../../../api/api";

export interface LoyaltyPointConfigResponse {
  readonly action: string;
  readonly description: string;
  readonly staticConfig: StaticConfig | null;
  readonly dynamicConfig: DynamicConfig | null;
  readonly enabled: boolean;
}

export interface UpdateLoyaltyPointConfigRequest {
  readonly action: string;
  readonly staticConfig: StaticConfig | null;
  readonly dynamicConfig: DynamicConfig | null;
  readonly enabled: boolean;
}

export interface StaticConfig {
  points: number;
}

export interface DynamicConfig {
  multiplier: string;
}

export interface LoyaltyPoints {
  readonly points: number;
}

export interface LoyaltyPointsHistoryItem {
  readonly id: string;
  readonly userId: string;
  readonly amount: number;
  readonly orderId?: { readonly value: string; readonly userFriendly: number };
  readonly rewardId?: string;
  readonly createdAt: string;
}

export type LoyaltyPointsEventType =
  "LOYALTY_POINTS_ADDED" | "LOYALTY_POINTS_REVERTED" | "LOYALTY_POINTS_SPENT" | "LOYALTY_POINTS_REFUNDED";

export interface AdminLoyaltyPointsHistoryItem {
  readonly id: string;
  readonly userId: string;
  readonly amount: number;
  readonly pointsAfter: number;
  readonly orderId?: { readonly value: string; readonly userFriendly: number };
  readonly rewardId?: string;
  readonly createdAt: string;
  readonly type: LoyaltyPointsEventType;
}

export async function listLoyaltyPointConfigs(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<{ items: LoyaltyPointConfigResponse[] }>("/loyalty/points/configs", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function updateLoyaltyPointConfig(request: UpdateLoyaltyPointConfigRequest, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.put<LoyaltyPointConfigResponse>(
    `/loyalty/points/configs/${request.action}`,
    { staticConfig: request.staticConfig, dynamicConfig: request.dynamicConfig, enabled: request.enabled },
    {
      signal: abortSignal,
    },
  );
  return response.data;
}

export async function getLoyaltyPoints(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<LoyaltyPoints>("/loyalty/points", {
    signal: abortSignal,
  });
  return response.data;
}

export async function getLoyaltyPointsHistory(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<{ items: LoyaltyPointsHistoryItem[] }>("/loyalty/points/history", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function getAdminLoyaltyPointsHistory(
  userIds: string[],
  page?: number,
  size?: number,
  abortSignal?: AbortSignal,
) {
  const response = await przezmorzeApi.get<{ items: AdminLoyaltyPointsHistoryItem[] }>(
    "/admin/loyalty/points/history",
    {
      signal: abortSignal,
      params: { userIds: userIds.join(","), page, size },
    },
  );
  return response.data.items;
}

export interface RefundLoyaltyPointsRequest {
  eventId: string;
}

export async function refundPoints(request: RefundLoyaltyPointsRequest, abortSignal?: AbortSignal) {
  await przezmorzeApi.post<void>(`/loyalty/points/history/${request.eventId}/refund`, {
    signal: abortSignal,
  });
}
